class ScrollHeader {
  constructor(el, options = {}) {
    this.el = el;
    this.document = document.documentElement;
    this.prevScroll = window.scrollY || this.document.scrollTop;

    const defaultOptions = {
      scrollOffset: 120,
      containerSelector: '#main',
      nameSpace: 'page-header',
      scrolledClass: 'scrolled',
      scrolledOffsetClass: 'scrolled-offset',
      hideClass: 'hide',
      bodyScrolledClass: 'scrolled',
    };

    this.options = { ...defaultOptions, ...options };
    this.containerEl = document.querySelector(this.options.containerSelector);
    this.scrolledClass = `${this.options.nameSpace}--${this.options.scrolledClass}`;
    this.scrolledOffsetClass = `${this.options.nameSpace}--${this.options.scrolledOffsetClass}`;
    this.hideClass = `${this.options.nameSpace}--${this.options.hideClass}`;
    this.bodyScrolledClass = this.options.bodyScrolledClass;

    this.directions = {
      INIT: 0,
      UP: 1,
      DOWN: 2,
    };

    this.direction = this.directions.INIT;
    this.prevDirection = this.directions.INIT;

    this.addEventListeners();
  }

  addEventListeners() {
    window.addEventListener('scroll', this.checkScroll.bind(this));
  }

  checkScroll() {
    const curScroll = window.scrollY || this.document.scrollTop;

    if (curScroll > this.prevScroll) {
      this.direction = this.directions.DOWN;
    } else if (curScroll < this.prevScroll) {
      this.direction = this.directions.UP;
    }

    if (this.direction !== this.prevDirection) {
      document.body.classList.add(this.bodyScrolledClass);
      this.handleChangedScrollDirection(this.direction, curScroll);
      this.setScrolled();
    }

    if (curScroll <= 0) {
      document.body.classList.remove(this.bodyScrolledClass);
      this.el.classList.remove(this.scrolledClass);
      this.unsetScrolled();
    } else if (curScroll < this.options.scrollOffset) {
      this.el.classList.remove(this.scrolledOffsetClass);
    }

    this.prevScroll = curScroll;
  }

  handleChangedScrollDirection(direction, curScroll) {
    if (direction === this.directions.DOWN) {
      this.el.classList.add(this.scrolledClass);

      if (curScroll > this.options.scrollOffset) {
        this.el.classList.add(this.scrolledOffsetClass);
        this.el.classList.add(this.hideClass);
        this.prevDirection = direction;
      }
    }

    if (direction === this.directions.UP) {
      this.el.classList.remove(this.hideClass);
      this.prevDirection = direction;
    }
  }

  setScrolled() {
    this.el.style.position = 'fixed';
    this.el.style.left = 0;
    this.el.style.top = 0;
    this.el.style.width = '100%';

    this.containerEl.style.paddingTop = `${this.el.offsetHeight}px`;
  }

  unsetScrolled() {
    this.el.style.position = 'initial';
    this.el.style.left = 'auto';
    this.el.style.top = 'auto';
    this.el.style.width = 'auto';

    this.containerEl.style.paddingTop = 0;
  }
}

export default ScrollHeader;
